export default {
  app: "Jaohui 工作台",
  newBrief: "新建 Brief",
  myBriefs: "我的 Brief",
  workbench: "团队工作台",
  members: "成员与账号",
  model: "模型配置",
  logout: "退出",
  taskList: "任务清单",
  submit: "确认并提交给团队",
  addChange: "补充需求",
  send: "发送",
  emptyQueue: "暂时没有客户已提交的 Brief",
  common: {
    save: "保存",
    cancel: "取消",
    edit: "编辑",
    add: "添加",
    delete: "删除",
    submit: "提交",
    confirm: "确认",
    saving: "保存中",
    close: "关闭",
    download: "下载",
    previous: "上一页",
    next: "下一页",
    all: "全部",
    draft: "草稿",
    active: "执行中",
    completed: "已完成",
    pending: "待处理",
    blocked: "阻塞",
    cancelled: "已取消",
    fromTo: "{start} 至 {end}",
  },
  upload: {
    open: "上传",
    chooseSource: "选择上传方式",
    media: "照片或视频",
    mediaHint: "打开手机相册选择",
    photo: "照片",
    photoHint: "从手机相册选择图片",
    file: "文件",
    fileHint: "从手机或电脑文件中选择",
  },
  shell: {
    home: "工作台",
    collaboration: "我的协同",
    dispatch: "调度审核",
    client: "客户",
    staff: "内部员工",
    admin: "管理员",
    partner: "合作伙伴",
    partnerService: "合作伙伴服务",
    partnerRequests: "合作需求",
    collapse: "折叠顶部导航",
    expand: "展开顶部导航",
    deleteBrief:
      "确定删除这份 Brief 吗？删除后会同时删除会话、任务、交付和变更记录，无法恢复。",
    deleteNamed: "删除 {title}",
  },
  login: {
    title: "登录 Jaohui 工作台",
    hero: "把客户想法变成可执行的工作。",
    subtitle: "客户使用自己的语言沟通，团队获得清晰的中文执行事项。",
    access: "受邀客户、内部团队与管理员使用独立权限进入工作台。",
    hint: "使用管理员创建的账号登录。",
    username: "账号",
    password: "密码",
    action: "登录",
    working: "登录中…",
    failed: "登录失败",
  },
  brief: {
    genericType: "通用需求",
    partnerGenericType: "产品宣传物料",
    partnerType: "合作伙伴业务",
    partnerIntro: "与 AI 核对产品事实、受众、内容结构和交付规格，完整后再提交团队。",
    intro: "像聊天一样补充需求，确认后再提交给团队。",
    inputPlaceholder: "输入中文、英文、法语或混合语言的需求内容…",
    resumeFailed: "任务恢复失败",
    pageFailed: "页面加载失败，请重试",
    sendFailed: "发送失败，请检查网络后重试",
    documentOnly:
      "聊天阶段仅支持 Word 或 TXT。图片和视频请在确认方案后，上传到项目草稿中的具体任务。",
    uploadFailed: "文件上传失败，请重试",
    loading: "正在加载...",
    loadFailed: "页面暂时没有加载成功",
    reload: "重新加载",
    historyHint: "每一份 Brief 都保留独立会话、任务、变更和交付记录。",
    empty: "还没有 Brief。",
    changeTitle: "修改 Brief 标题",
    autoDetected: "已自动识别",
    confirmType: "请确认业务类型",
    chooseType: "选择业务类型",
    changeType: "更改业务类型",
    confirmedVersion: "已确认 Brief v{version}",
    deleteCurrent: "删除当前会话",
    conversation: "需求沟通",
    fullSolution: "完整方案",
    you: "你",
    researchDone: "研究与规划已完成",
    stopRun: "停止当前任务",
    collapseTrace: "折叠过程",
    expandTrace: "展开过程",
    references: "参考资料",
    uploadDocument: "上传 Word 或 TXT",
    uploadImage: "从相册选择图片",
    imageMessage: "请分析我发送的图片，并结合图片内容继续整理需求。",
    pendingImages: "待发送图片",
    removeImage: "移除图片",
    imageLimit: "每条消息最多发送 5 张图片",
    messages: "沟通与交付",
    versions: "版本与变更",
    confirmed: "已确认",
    changeNumber: "变更 #{id}",
    waitingTeam: "等待团队确认",
    changeHint: "团队将收到 AI 整理后的中文执行说明。",
  },
  dashboard: {
    title: "项目工作台",
    subtitle: "查看项目进度、时间计划、阻塞和待处理事项。",
    newRequest: "新建需求",
    awaitingAcceptance: "待我验收",
    adminReview: "管理员分析中",
    adminClientReview: "等待你确认管理员方案",
    adminConfirmed: "已确认，等待分派",
    adminRevision: "方案调整中",
    assigned: "已分派团队",
    intake: "需求沟通",
    drafting: "方案整理",
    solutionReview: "方案待确认",
    projectDraft: "项目草稿",
    submitted: "已提交",
    teamAccepted: "团队已接单",
    scheduled: "已排期",
    inProgress: "执行中",
    awaiting: "等待验收",
    revision: "修改中",
    noDate: "待团队评估日期",
    blockedCount: "{count} 项阻塞",
    waitYou: "等待你处理",
    teamWorking: "团队处理中",
    collapseTimeline: "收起时间轴",
    showTimeline: "查看时间轴",
    empty: "当前分类下还没有项目。",
    deleteTitle: "删除 {title}",
    deleteConfirm:
      "确定删除“{title}”吗？会话、任务、交付和变更记录将同时删除，无法恢复。",
  },
  profile: {
    title: "我的称呼与长期偏好",
    loading: "正在读取客户资料",
    summary: "{name} · 已记住 {count} 项长期记忆",
    preferredName: "Agent 对你的称呼",
    organization: "组织 / 公司",
    industry: "所在行业",
    brandSummary: "品牌背景",
    preferences: "长期偏好，每行一项",
    preferencePlaceholder: "例如：默认使用英文成品文字",
    saved: "客户资料已保存，后续 Agent 会自动使用。",
    save: "保存资料",
    portrait: "自动画像",
    portraitVersion: "画像 v{version}",
    memoryEvidence: "已提炼的长期记忆",
    updated: "最近更新 {time}",
    emptyMemory: "继续使用后，Agent 会从明确表达和重复偏好中自动提炼。",
  },
  agent: {
    processing: "Agent 正在处理",
    ready: "完整方案已准备好",
    missing: "还需要确认 {count} 项",
    done: "本轮处理已完成",
    collapse: "折叠任务进度",
    expand: "展开任务进度：{title}",
    title: "Agent 任务进度",
    runProgress: "本轮处理",
    completeness: "方案完整度",
    needTalk: "还需要沟通",
    readyHint: "可前往完整方案核对并创建项目草稿。",
  },
  solution: {
    overview: "方案概览",
    confirmPage: "核对并确认",
    itemPage: "第 {index} 项 · {title}",
    executionTask: "执行任务",
    fullSolution: "完整方案",
    waiting: "等待 AI 整理方案",
    completeness: "完整度 {score}%",
    webReferences: "联网参考",
    checklist: "两级执行清单",
    lockedCopy: "成品文字 · 保持原文",
    clientTask: "客户任务说明",
    deliverables: "交付",
    teamDetails: "团队执行细节",
    items: "{count} 项",
    acceptance: "核查：{items}",
    finalStep: "最后一步",
    confirmTitle: "核对并确认方案",
    preflight: "提交前核查事项",
    canAdd: "仍可补充",
    creating: "正在创建项目草稿",
    confirmCreate: "确认方案并创建项目草稿",
    missing: "方案仍缺少：{items}",
    switchPages: "切换方案页面",
    emptyHint: "发送需求后，AI 的完整方案会显示在这里。",
  },
  project: {
    expected: "预计完成：{date}",
    adminReview: "管理员方案确认",
    adminReviewHint:
      "核对方案、锁定文字和成品语言。确认后由管理员分派员工；如有问题请退回并写明调整要求。",
    reviewPlaceholder: "确认意见或需要调整的内容",
    approve: "确认无误",
    revise: "要求调整",
    overview: "项目概览",
    tasks: "执行清单",
    timeline: "时间轴",
    changes: "版本与变更",
    noSolution: "暂无完整方案",
    sources: "参考资料",
    confirmedRequirements: "已确认要求",
    languageTitle: "成品语言与锁定文字",
    languageHint:
      "客户原文保持不变；中文仅用于团队理解；最终作品按成品语言输出。",
    sourceText: "客户原文",
    sourceLanguage: "原文语言",
    outputText: "成品文字",
    outputLanguage: "成品语言",
    languageExample: "例如 English",
    policy: "处理方式",
    preserve: "原样保留",
    translate: "翻译",
    localize: "本地化改写",
    clientConfirmed: "客户已核实",
    saveLanguage: "保存语言设置",
    taskProgress: "任务进度",
    steps: "{done} / {total} 步",
    messages: "沟通与交付",
    requestTodo: "申请新增待办",
    acceptance: "验收标准",
    levelOne: "一级阶段",
    levelTwo: "二级步骤",
    executionReference: "执行参考表",
    executionReferenceHint: "分镜、画面或技术规格，需要时展开",
    check: "核查：{items}",
    assets: "执行素材",
    preview: "弹窗预览",
    noAssets: "暂无正式执行素材。",
    addChange: "新增变更",
    projectVersion: "项目 V{version}",
    changeNumber: "变更 #{id}",
    awaitingImpact: "等待团队评估影响",
    approveChange: "批准变更",
    reject: "拒绝",
    noChanges: "暂无变更记录。",
    adminReviewStage: "已提交，等待管理员分析",
    clientReviewStage: "管理员方案待你确认",
    confirmedStage: "你已确认，等待管理员分派",
    revisionStage: "管理员或客户要求调整",
    assignedStage: "管理员已分派团队",
    submittedStage: "已提交，等待团队接单",
    acceptedStage: "团队已接单",
    scheduledStage: "已排期",
    inProgressStage: "执行中",
    acceptanceStage: "等待你的验收",
    revisionWorkStage: "修改中",
    completedStage: "已完成",
  },
  draftEditor: {
    itemPoster: "海报",
    itemTask: "任务",
    unitPoster: "张",
    unitTask: "项",
    title: "项目草稿",
    hint: "核对任务内容和日期，检查无误后提交管理员审核。",
    infoPage: "项目信息",
    solutionPage: "完整方案",
    requirementsPage: "客户要求",
    submitPage: "提交确认",
    itemPage: "第 {index} 项 · {title}",
    executionTask: "执行任务",
    projectName: "项目名称",
    start: "计划开始",
    end: "计划完成",
    expectedEnd: "期望完成",
    saveInfo: "保存项目信息",
    confirmedSolution: "已确认完整方案",
    requirements: "客户明确要求核查",
    requirementsHint:
      "内容、台词、主题、限制和注意事项可修改；逐项确认后才能正式提交。",
    addRequirement: "新增核查项",
    requirementCategory: "要求类别",
    attention: "注意事项",
    content: "内容要求",
    dialogue: "台词文案",
    theme: "主题方向",
    other: "其他要求",
    requirementTitle: "核查事项",
    requirementDescription: "客户明确要求和具体限制",
    verified: "已核实无误",
    deleteRequirement: "删除核查项",
    saveRequirements: "保存核查清单",
    taskList: "{item}清单",
    reviewed: "已确认 {done} / {total}，每{unit}单独核对内容和日期",
    taskName: "{item}名称",
    sourceCopy: "客户原文 / 成品文字",
    sourceCopyHint:
      "客户提供的文字保持原样；没有成品文字时填写客户确认的内容说明。",
    finalCopy: "成品文字",
    preserveOriginal: "English · 保持原文",
    editCopy: "编辑成品文字",
    finishEdit: "完成编辑",
    teamBrief: "中文制作要求",
    saveTask: "保存{item}",
    deleteTask: "删除{item}",
    optionalAssets: "本{item}素材（可选）",
    optionalAssetsHint: "已在其他渠道交付、由 AI 生成或本任务不需要时可留空。",
    addAsset: "添加素材",
    chooseFromAlbum: "从相册选择",
    chooseFile: "选择文件",
    noAssets: "尚未归档正式素材。",
    archiveHint: "对话参考可归档到此任务",
    archive: "归档 {name}",
    confirmItem: "确认本项内容",
    confirmedItem: "本项已确认",
    executionDetails: "团队执行细节",
    concreteSteps: "{count} 个具体步骤",
    acceptanceLines: "验收标准（每行一项）",
    todoList: "执行清单",
    todoTitle: "待办事项标题",
    addTodo: "新增待办事项",
    addTodoPlaceholder: "输入一项具体、可执行的待办事项",
    defaultAcceptance: "按已确认要求完成并可核查",
    todoDescription: "完成“{title}”并提交可核查结果。",
    twoLevel: "两级执行清单",
    levelOne: "一级",
    levelTwo: "二级",
    stageGoal: "阶段目标和交付结果",
    stageAcceptance: "阶段核查标准，每行一项",
    stepDescription: "具体怎么做、输入和输出是什么",
    stepAcceptance: "核查标准，每行一项",
    addStage: "添加阶段",
    addStep: "添加步骤",
    newTask: "添加任务",
    finalStep: "最后一步",
    submitReview: "提交管理员审核",
    submitHint: "检查项目名称、日期、客户要求和全部任务后提交管理员审核。",
    validationMissing: "提交前还需处理 {count} 项",
    validationPassed: "提交检查已通过",
    switchPages: "切换项目草稿页面",
  },
  progress: {
    intake: "需求沟通",
    drafting: "方案整理",
    review: "方案待确认",
    draft: "项目草稿",
    submitted: "待团队接单",
    accepted: "团队已接单",
    scheduled: "已排期",
    inProgress: "执行中",
    awaiting: "待客户验收",
    revision: "修改中",
    completed: "已完成",
    completedCount: "{done} / {total} 项完成",
    blockedCount: "{count} 项阻塞",
    delayed: "已延期",
    waitClient: "等待客户处理",
    teamWorking: "团队处理中",
  },
  timeline: {
    title: "项目甘特图",
    subtitle: "计划条在上，实际进度在下",
    taskStep: "任务 / 执行步骤",
    levelOne: "一级",
    levelTwo: "二级",
    today: "今天",
    pending: "待处理",
    scheduled: "已排期",
    inProgress: "进行中",
    blocked: "阻塞",
    done: "已完成",
    ready: "待验收",
    accepted: "已验收",
    cancelled: "已取消",
    empty: "团队排期后，这里会显示任务、一级阶段和二级步骤。",
  },
  execution: {
    videoLabel: "分镜执行规格",
    videoNote: "镜头、画面、台词、声音与验收",
    dramaLabel: "剧情制作规格",
    dramaNote: "剧情、角色、镜头与连续性",
    designLabel: "设计需求规格",
    designNote: "内容、画面、版式、尺寸与交付",
    websiteLabel: "产品功能规格",
    websiteNote: "模块、功能、字段、状态与权限",
    developmentLabel: "技术实现合同",
    developmentNote: "接口、数据、校验、异常与验收",
    articleLabel: "内容生产规格",
    articleNote: "结构、事实、语气、篇幅与发布",
    defaultLabel: "执行需求规格",
    defaultNote: "客户确认内容与可核查验收要求",
    tableTitles: {
      storyboard: "逐镜头分镜与内容表",
      asset_continuity: "跨镜头视觉与声音一致性清单",
      delivery_qa: "成片交付质量检查表",
      story_bible: "故事、角色与剧集设定表",
      narrative_storyboard: "剧情与逐镜头分镜表",
      continuity_qa: "剧情连续性与成片核查表",
      poster_spec: "海报画面与文案需求清单",
      logo_spec: "Logo / VI 设计规格清单",
      packaging_spec: "包装版面与印刷内容清单",
      ui_screen_spec: "界面、组件与状态需求清单",
      illustration_spec: "角色与插画视觉锚点清单",
      design_qa: "设计成品与源文件质检表",
      website_module: "页面模块与功能需求清单",
      user_flow_state: "用户流程、状态与权限矩阵",
      experience_acceptance: "产品体验与发布验收表",
      technical_contract: "技术模块、接口与数据合同清单",
      test_matrix: "测试与验收证据矩阵",
      release_plan: "发布、监控与回退计划",
      article_outline: "内容结构、事实与发布要求清单",
      fact_source_matrix: "事实、证据与锁定表述清单",
      publication_qa: "内容发布与交付质检表",
    },
  },
  asset: {
    previewFailed: "预览失败",
    downloadOriginal: "下载原文件",
    closePreview: "关闭预览",
    loading: "正在加载预览...",
    unsupported: "该文件不支持在线预览。",
    download: "下载文件",
  },
};
